import { useChannelContext } from "@sendbird/uikit-react/Channel/context";
import { CoreMessageType } from "@sendbird/uikit-react/types/utils";
import { useFacilityTimeZone } from "./utils/useFacilityTimeZone";
import { hideMessage, showDateSeparator } from "./utils/helpers";
import { ReactNode } from "react";
import { SendbirdDateSeparator } from "./SendbirdDateSeparator";

interface ChannelMessageWrapperProps {
  message: CoreMessageType;
  children: ReactNode;
}

export function ChannelMessageWrapper({ message, children }: ChannelMessageWrapperProps) {
  // Internally Sendbird will render the date separator if the message is the first message of the day
  // However because we're hiding messages, we need more granular control for showing the separator.
  // An example is when we have a day with the following order: hidden message, visible message
  // We'd want the visible message to have the separator. This wrapper ensures we have this granularity
  // by checking messages preceding the current message.

  const { allMessages } = useChannelContext();
  const timeZone = useFacilityTimeZone();

  if (hideMessage(message)) {
    return <></>;
  }

  const shouldShowSeparator = showDateSeparator({ message, allMessages, timeZone });

  return (
    <>
      {shouldShowSeparator && (
        <SendbirdDateSeparator date={new Date(message.createdAt)} timeZone={timeZone} />
      )}
      {children}
    </>
  );
}
